// utils
import React, { useEffect, useState } from "react";
import { Link, useMatch } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../utils/langUtils";
import { globalLoading } from "../../../components/global";
import { determineColor } from "../components/blogColor";
import { article404ContainerHeight } from "../components/article404ContainerHeight";
import { articleContainerHeight } from "../components/articleContainerHeight";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// components
import BlogLatest from "./components/blog-latest/blog-latest";
import BlogOlderStart from "./components/blog-older-start/blog-older-start";
import BlogOlderEnd from "./components/blog-older-end/blog-older-end";

// section
import SectionLoadingError from "../../../components/section-loading-error/section-loading-error";

// storage for data obtained from backend
let articlePreviews:any = null;
let requestErrorCode = "";
let requestErrorText = "";

/**
 * BLOG page
 * @returns main BLOG page for BLOG
 */
export default function Index() {

    const [isLoaded, setIsLoaded] = useState(false);
    const [requestError, setRequestError] = useState(false);


    // On PAGE load DATA from backend are REQUESTED
    useEffect(() => {
        // Sets GLOBAL LOADING to TRUE
        globalLoading.switch();

        //axios.get("/api/blog/getPreviewsAll", { params: { lang: language } })
        axios.get("/api/blog/getPreviewsAll", { params: { lang: language }, timeout: 10000 })
            .then(function (response) {

                articlePreviews = response.data.data.blogs;

                // DEBUG status 
                //console.log("status res: ", response.status);
                
                // Sets GLOBAL LOADING to FALSE
                globalLoading.switch();

                setIsLoaded(true);

                // DEBUG simulates waiting for data - used for debugging
                //window.setTimeout(() => {globalLoading.switch();}, 1000);
            })
            .catch(function (error) {
                // Sets GLOBAL LOADING to FALSE
                globalLoading.switch();

                // DEBUG whole error message
                //console.log(error);
                
                // error response from backend
                if(error?.response?.status >= 400 && error?.response?.status <= 599)
                {
                    console.log("status err:", error.response.status, error.response.statusText);
                    requestErrorCode = error.response.status.toString();
                    requestErrorText = error.response.statusText.toString();
                }
                // response from backend timeout
                else
                {
                    console.log("status err: 408 Request Timeout");
                    requestErrorCode = "408";
                    requestErrorText = "Request Timeout";
                }
                setRequestError(true);
                console.log(requestError);
            });
    }, [])

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation= translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }
    
    useEffect(() => {
        articleContainerHeight();
    })

    window.addEventListener("resize", (event) => {
        articleContainerHeight();
    });
    
    useEffect(() => {
        article404ContainerHeight();
    })
    window.addEventListener("resize", (event) => {
        article404ContainerHeight();
    });

    /** Handles rendering of obtained ARTICLES:
     * 1) latest ARTICLE is shown on top with different design
     * 2) all other ARTICLEs are shown bellow latest ARTICLE with uniform design
    */
    return (
        <div id="articleContainer">
            { requestError ? 
                <>
                    <SectionLoadingError requestErrorCode={requestErrorCode} requestErrorText={requestErrorText} reloadAddress={getUrlPrefix(language) + "blog"}></SectionLoadingError>
                </>
                : 
                <>
                </>
            }
            { isLoaded ? articlePreviews.slice(0, 1).map((item:any) => (
                    <>
                        <BlogLatest data={item}></BlogLatest>
                    </>
                )) 
                : 
                <>
                </>
            }

            { isLoaded ? 
                <div className="bg-white mb-5">
                    <Container>
                        { articlePreviews.slice(1).map((item:any, index: number) => (
                            <>
                                {((index % 2 === 0) ?
                                    (
                                        <>
                                            <BlogOlderStart data={item} color={determineColor(index)}></BlogOlderStart>
                                        </>
                                    ) 
                                    : 
                                    (
                                        <>
                                            <BlogOlderEnd data={item} color={determineColor(index)}></BlogOlderEnd>
                                        </>
                                    ))
                                }
                            </>
                            )) 
                        }
                    </Container>
                </div>
                : 
                <>
                </>
            }
        </div>
    );
}
